(function () {
  const header = () => {
    // Ensure the theme's JS/CSS mode is enabled
    // (Your menu-drawer CSS relies on .js being present)
    document.documentElement.classList.add("js");
    document.documentElement.classList.remove("no-js");

    // ------------------------------------------------------------
    // Existing hover mega menu (leave as-is)
    // ------------------------------------------------------------
    const megaMenuLinks = document.querySelectorAll(".list-menu--megamenu");
    megaMenuLinks.forEach((link) => {
      if (link.__fgHoverBound) return;
      link.__fgHoverBound = true;

      link.addEventListener("mouseenter", () => {
        link.classList.add("list-menu--megamenu-visible");

        link.addEventListener("mousemove", () => {
          link.classList.add("list-menu--megamenu-visible");
        });

        link.addEventListener("mouseleave", () => {
          setTimeout(() => {
            link.classList.remove("list-menu--megamenu-visible");
          }, 300);
          link.addEventListener("mouseenter", () => {
            link.classList.add("list-menu--megamenu-visible");
          });
        });
      });
    });

    // ------------------------------------------------------------
    // Stockmart drawer fix:
    // - Your CSS shows the drawer ONLY when details has .menu-opening
    //   and <html> has .js
    // - Some pages/devices were missing that state, so drawer stayed hidden
    // ------------------------------------------------------------
    const detailNodes = Array.from(
      document.querySelectorAll("header-drawer > details, menu-drawer > details")
    );

    const setState = (detailsEl) => {
      if (!detailsEl) return;

      if (detailsEl.open) {
        detailsEl.classList.add("menu-opening");
        document.body.classList.add("overflow-hidden");
      } else {
        detailsEl.classList.remove("menu-opening");

        // Only remove body lock if no other drawer is open
        const anyOpen = Array.from(
          document.querySelectorAll("header-drawer > details, menu-drawer > details")
        ).some((d) => d.open);

        if (!anyOpen) document.body.classList.remove("overflow-hidden");
      }
    };

    detailNodes.forEach((detailsEl) => {
      if (detailsEl.__fgDrawerBound) return;
      detailsEl.__fgDrawerBound = true;

      // Sync initial state
      setState(detailsEl);

      // Keep state in sync on native open/close
      detailsEl.addEventListener("toggle", () => setState(detailsEl));

      // Force summary click to toggle reliably (some scripts interfere)
      const summary = detailsEl.querySelector(":scope > summary");
      if (summary && !summary.__fgSummaryBound) {
        summary.__fgSummaryBound = true;

        summary.addEventListener(
          "click",
          (e) => {
            // We toggle ourselves so nothing else can prevent it
            e.preventDefault();
            e.stopPropagation();

            detailsEl.open = !detailsEl.open;
            setState(detailsEl);
          },
          true // capture
        );
      }

      // Close buttons inside the drawer
      const closeButtons = detailsEl.querySelectorAll(
        ".menu-drawer__close-button, .header__modal-close-button, [data-drawer-close]"
      );

      closeButtons.forEach((btn) => {
        if (btn.__fgCloseBound) return;
        btn.__fgCloseBound = true;

        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          detailsEl.open = false;
          setState(detailsEl);
        });
      });
    });

    // ESC closes any open drawer
    if (!window.__fgDrawerEscBound) {
      window.__fgDrawerEscBound = true;
      document.addEventListener("keydown", (e) => {
        if (e.key !== "Escape") return;
        const openDetails = Array.from(
          document.querySelectorAll("header-drawer > details[open], menu-drawer > details[open]")
        );
        openDetails.forEach((d) => {
          d.open = false;
          d.classList.remove("menu-opening");
        });
        document.body.classList.remove("overflow-hidden");
      });
    }
  };

  document.addEventListener("shopify:section:load", header);
  header();
})();